import { Instance, SnapshotOut, types } from 'mobx-state-tree'
import { withRootStore } from '../extensions'
// biome-ignore lint/style/useNodejsImportProtocol: <explanation>
import { Buffer } from 'buffer'
import { UserGameScheduleResponseModel, UserGameScheduleResponseModelType } from '../api-store'
import { numberWithCommas } from '../../utils/numberWithCommas'
import { formatBlindIncrease } from '../../utils/scheduleConfig'
import { EnvironmentStages } from '../environment'
import { ScheduledGameCardProps } from '../../components/ScheduledGameCard'

global.Buffer = Buffer

const ToastModel = types.model({
  kind: types.string,
  message: types.string
})

export interface ToastModelType extends Instance<typeof ToastModel> {}

export const UserGameSchedule = types
  .model({
    userGameScheduleFullResponse: types.maybeNull(UserGameScheduleResponseModel),
    gameScheduledAt: types.optional(types.Date, new Date()),
    toast: types.maybeNull(ToastModel)
  })
  .extend(withRootStore)
  .views((self) => ({
    get formattedGameScheduleFullResponse(): ScheduledGameCardProps {
      const blindTime = self.userGameScheduleFullResponse?.blindTimer ?? 0
      const startingChips = self.userGameScheduleFullResponse?.startingChips ?? 0
      // Legacy API uses actionTime; map to turnDuration for ScheduledGameCard
      const actionTime = self.userGameScheduleFullResponse?.actionTime ?? 0
      const gameKind = self.userGameScheduleFullResponse?.gameKind ?? ''
      const hostName = self.userGameScheduleFullResponse?.hostName ?? ''
      const hostedByCurrentUser = self.userGameScheduleFullResponse?.isHost
      const hash = self.userGameScheduleFullResponse?.hash ?? ''
      const gameScheduledCard = {
        name: self.userGameScheduleFullResponse?.name ?? '',
        gameType: gameKind,
        blindTime: formatBlindIncrease(blindTime),
        startingChips: `${numberWithCommas(startingChips)} starting chips`,
        turnDuration: `${actionTime} second actions`,
        scheduledAt: new Date(self.userGameScheduleFullResponse?.scheduleTime),
        hostedBy: hostedByCurrentUser ? undefined : hostName,
        isHost: hostedByCurrentUser,
        hash
      }

      return gameScheduledCard
    },
    get qrUrl() {
      const STAGE = process.env.EXPO_PUBLIC_STAGE
      const hash = self.userGameScheduleFullResponse?.hash ?? ''
      const isProd = STAGE === EnvironmentStages.prod
      const url = isProd
        ? `https://app.pokerpower.com/game/join/accept-invite/${hash}`
        : `https://app.dev.pokerpower.com/game/join/accept-invite/${hash}`

      return url
    }
  }))
  .actions((self) => ({
    setUserGameScheduleFullResponse(value: UserGameScheduleResponseModelType | null) {
      self.userGameScheduleFullResponse = value
    },
    setGameScheduledAt(date: Date) {
      self.gameScheduledAt = date
    },
    setToast(toast: ToastModelType | null) {
      self.toast = toast
    }
  }))

/**
 * The GameModalQueueStore instance.
 */
export type UserGameScheduleStore = Instance<typeof UserGameSchedule>

/**
 * The data of a GameModalQueueStore.
 */
export type UserGameScheduleSnapshot = SnapshotOut<typeof UserGameSchedule>
